import { render, staticRenderFns } from "./settlement-consignee.vue?vue&type=template&id=50a2bdda&scoped=true"
import script from "./settlement-consignee.vue?vue&type=script&lang=js"
export * from "./settlement-consignee.vue?vue&type=script&lang=js"
import style0 from "./settlement-consignee.vue?vue&type=style&index=0&id=50a2bdda&prod&lang=css"
import style1 from "./settlement-consignee.vue?vue&type=style&index=1&id=50a2bdda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a2bdda",
  null
  
)

export default component.exports